import Glide, { Breakpoints, Controls, Swipe, Images } from '@glidejs/glide/dist/glide.modular.esm';
import { Autocomplete } from '../components/Autocomplete';
import { getDir } from '../../common/components/utils/utils';
import loadGoogleMapsApi from '../utils/MapManager';

const sliderInstances = [];

/**
 * When tabs change on the homepage update the countries sliders.
 * Because they are hidden and styles can't be calculated.
 */
export function onTabsChange(id) {
	if (id === 'countries') sliderInstances.forEach((slider) => slider.update());
}

function initCountriesSlider() {
	const countrySliders = [...document.querySelectorAll('[data-slider-home-countries]')];

	countrySliders.forEach((slider) => {
		sliderInstances.push(
			new Glide(slider, {
				perView: 2.8,
				gap: 32,
				rewind: false,
				direction: getDir(),
				breakpoints: {
					600: {
						perView: 1.2,
						gap: 24,
					},
				},
			}).mount({ Controls, Breakpoints, Swipe, Images })
		);
	});
}

function initClinicsSlider() {
	const countrySliders = [...document.querySelectorAll('[data-slider-home-clinics]')];

	countrySliders.forEach((slider) => {
		sliderInstances.push(
			new Glide(slider, {
				type: 'carousel',
				perView: 3,
				gap: 32,
				direction: getDir(),
				animationTimingFunc: 'linear',
				swipeThreshold: 40,
				breakpoints: {
					1000: {
						perView: 2,
						gap: 24,
					},
					600: {
						perView: 1,
						gap: 16,
					},
				},
			}).mount({ Controls, Breakpoints, Swipe, Images })
		);
	});
}

/**
 * When we scroll, after search module autocomplete - in header we should show autocomplete
 */
function createHeaderScrollObserver() {
	const autocompleteForm = document.querySelector('.autocomplete__form');
	const headerHomepage = document.querySelector('.navigation__homepage');

	const observer = new IntersectionObserver(
		(entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					headerHomepage.classList.remove('scroll');
				} else {
					headerHomepage.classList.add('scroll');
				}
			});
		},
		{ rootMargin: '-80px' }
	);
	if (autocompleteForm) observer.observe(autocompleteForm);
}

/**
 * Initialize the autocomplete in the header section.
 */
function initHomepageAutocomplete() {
	window.mapQueue.push(() => {
		// eslint-disable-next-line no-unused-vars
		const header = new Autocomplete('[data-type="autocomplete"]', '[data-auto="results-wrapper"]');
	});
	loadGoogleMapsApi();
}

/**
 * Initialize the autocomplete in the search module section.
 */
function initSearchmoduleAutocomplete() {
	window.mapQueue.push(() => {
		// eslint-disable-next-line no-unused-vars
		const searchModule = new Autocomplete(
			'[data-type="autocomplete__search-module"]',
			'[data-auto="results-wrapper__search-module"]'
		);
	});
	loadGoogleMapsApi();
}

export function init() {
	console.info('Initializing `Home`');
	initCountriesSlider();
	initClinicsSlider();
	initHomepageAutocomplete();
	createHeaderScrollObserver();
	initSearchmoduleAutocomplete();
}
